// Listing widths: only the column whose value can be long (a reference, a product name…)
// stretches; every other column is sized to its content (width 1% + no wrapping), so the free
// space goes where it's useful instead of being spread evenly.
const fitColumns = (columns, stretchAccessor) => columns.map((col) => (
    col.accessor === stretchAccessor
        ? col
        : { ...col, width: col.width ?? '1%', className: [col.className, 'text-nowrap'].filter(Boolean).join(' ') }
));

export default fitColumns;
